import React, { ReactNode } from "react";

interface MessagingSettingRowProps {
	label: string;
	/** Alternate rows are tinted, like the other rows on Client Details. */
	isStriped: boolean;
	children: ReactNode;
	error?: string;
}

/** Label on the left, value or control on the right — the Client Details row layout. */
export const MessagingSettingRow = ({
	label,
	isStriped,
	children,
	error,
}: MessagingSettingRowProps) => (
	<div
		className={`flex min-h-[3.5rem] flex-row items-center p-3 ${
			isStriped ? "bg-brand-50" : ""
		}`}
	>
		<p className="w-1/2 text-sm font-bold text-neutral-900">{label}:</p>
		<div className="flex w-1/2 flex-col items-start gap-1 text-sm text-neutral-900">
			{children}
			{error && <p className="text-xs text-danger">{error}</p>}
		</div>
	</div>
);
